var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"codemirror"},[_c('div',{ref:"ace",staticClass:"ace-editor",style:({ height: _vm.displayHeight })})])
}
var staticRenderFns = []

export { render, staticRenderFns }